import { Component, OnInit, Input } from '@angular/core';
import { StageService } from '../services/stage-modal.service';

@Component({
  selector: 'queoval-stage-extranet',
  templateUrl: './extranet.component.html',
  styleUrls: ['./extranet.component.css']
})

export class ExtranetComponent implements OnInit {
  constructor(
    public service: StageService,
  ) { }



  public tabs: Array<{ Type: ExtranetOnglet, Font: string, Name: string, Active: boolean,  Visible: boolean, Locked: boolean }> = [
    { Active: true,  Visible: true, Locked: false, Name: 'Extranet', Type: ExtranetOnglet.Extranet, Font: 'fas fa-university mr-2', },
    { Active: false, Visible: true, Locked: false, Name: 'Questionnaires', Type: ExtranetOnglet.Questionnaire, Font: 'fas fa-question mr-2', },
    { Active: false, Visible: true, Locked: false, Name: 'Digital learning', Type: ExtranetOnglet.DigitalLearning, Font: 'fas fa-graduation-cap mr-2', }
  ];


  public ngOnInit(): void {
  }

  public ActiveTab(indexType: number): void {
    this.tabs.forEach(tab => {
      if (tab.Type === indexType && tab.Visible && !tab.Locked) {
        tab.Active = true;        
      }
      else tab.Active = false;
    });
    if (this.tabs.findIndex(t => t.Active) === -1) this.tabs[0].Active = true;
  }

}


export enum ExtranetOnglet {
  Extranet,
  Questionnaire,
  DigitalLearning,
}
